import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  /* Meta Pixel Code */
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-brand-navy font-sans text-white selection:bg-brand-yellow selection:text-brand-navy" data-id="element-0" data-mp="38lrpeemjd4ho">
      <noscript data-id="element-1" data-mp="3dl4ktnrh3jvv">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3dlnsmbnesrw6" />
      </noscript>

      <Hero data-id="element-3" data-mp="sssskuh76od1" />
      <main data-id="element-4" data-mp="swgk5o3310p4">
        <ProblemSection data-id="element-5" data-mp="36hvn4muyo06" />
        <SolutionSection data-id="element-6" data-mp="35ox2qy1z4t4" />
        <BonusesSection data-id="element-7" data-mp="34x13f0jn52b" />
        <BenefitsSection data-id="element-8" data-mp="38ktgau95lfg" />
        <OfferSection data-id="element-9" data-mp="3ud1en72ulk9k" />
        <GuaranteeSection data-id="element-10" data-mp="3ubrg6gs32a2e" />
        <Testimonials data-id="element-11" data-mp="3ucjbrrlok7so" />
        <FAQSection data-id="element-12" data-mp="3uf5gljh6s977" />
        <FinalCTA data-id="element-13" data-mp="d4e9i476jx1z" />
      </main>
      <Footer data-id="element-14" data-mp="d3cuxpqygsfi" />
      {showPurchasePopup && <PurchasePopup data-id="element-15" data-mp="d2biphy7dzw7" />}
    </div>;
}